<template>
  <div> <!-- Just a container too consolidate the whole component -->
    <v-btn fab text small class="header-arrow-button" @click="calendarAction('prev')">
      <v-icon small>mdi-arrow-left-drop-circle-outline</v-icon>
    </v-btn>
    {{ calendar_props.title }}

    <!-- New menu -->
    <v-menu
      dense
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"

        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense >
        <!-- GO TO TODAY -->
        <v-list-item   @click="calendarAction('setToday')">          
          <v-list-item-title>Today</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar-today</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-group no-action @click.stop>
          <template v-slot:activator>
            <v-list-item-title>
              Views modes ( {{ typeToLabel[calendar_props.type] }} )
            </v-list-item-title>
          </template>
          <v-list-item-group 
            v-model="type_selected" 
            class="pl-10" 
            active-class="qmkey-explorer-view-active"
          >
            <v-list-item
              v-for="(label, type) in typeToLabel"
              :key="type"
              @click="calendarAction('setType', type)"
              > <!-- TODO: WIP! -->
              <v-list-item-title>{{ label }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon>{{ typeToIcon[type] }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group
          no-action
          @click.stop
        >
          <template v-slot:activator>
            <v-list-item-title>
              Days to show <!-- ( {{weekdays[days_selected].label}} ) --> 
              <!--FIXME:Error days_selected is not defined -->
            </v-list-item-title>
          </template>
          <v-list-item-group 
            v-model="days_selected" 
            class="pl-10" 
            active-class="qmkey-explorer-view-active"
          >
            <v-list-item
              v-for="(days, i) in weekdays"
              :key="i"
              @click="calendarAction('setDays', days.value)"
              :class="days.value == weekday ? 'menu-options-selected' : ''"
            > <!-- TODO: WIP! -->
              <v-list-item-title>{{ days.label }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon>mdi-numeric-{{ i }}-circle-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group >
        </v-list-group>
      </v-list>
    </v-menu>
    <!-- // New menu -->
    <v-btn fab text small class="header-arrow-button" @click="calendarAction('next')">
      <v-icon small>mdi-arrow-right-drop-circle-outline</v-icon>
    </v-btn>
  </div>
</template>


<script>
export default {
  name: 'ExplorerCalendarHeader',
  components: {},

  props: ['calendar_props'],

  data: () => ({
    typeToLabel: {
       month: 'Mensual',
       week: 'Semanal',
       day: 'Diario',
    },
    typeToIcon: {
       month: 'mdi-calendar-month',
       week: 'mdi-calendar-week',
       day: 'mdi-calendar-blank',
    },
    dayToLabel: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
    },
    weekdays: [
      { label: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
      { label: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
      { label: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { label: 'Mon, Wed, Fri', value: [1, 3, 5] },
    ],
    weekday: [],
    type_selected: 0,
    days_selected: 1,
   }),

   methods: {
     calendarAction(action, ...args) {
      console.log('calendarheader', action, args)
      if ( action == 'setDays'){
        this.weekday = args
      }
      this.$emit('calendar-action', action, ...args);
     },
     setSelected(obj){
       console.log('CalendarHeader.setSelected', obj)
     }
   }
 }
</script>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>
